import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../state'

import * as table from './table'
import * as variable from './variable'

@ngCore.Component({
  imports: [table.Component, variable.Component, ds.button.Component],
  selector: 'atn-variables-builder',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.editingVariables.Feature} */
  private readonly _editingVariablesFeature = ngCore.inject(
    state.admin.editingVariables.Feature,
  )

  /**
   * Currently focused variable definition for editing
   */
  public readonly focusedVariableDefinitionSg = ngCore.computed(
    (focused = this._editingVariablesFeature.selectors.focused.asSignal()) =>
      focused?.definition,
  )

  /**
   * Returns true if existing definition is being updated
   */
  public readonly isUpdatingSg = ngCore.computed(
    (focused = this._editingVariablesFeature.selectors.focused.asSignal()) =>
      // If focused variable definition has an id it means we are editing
      // existing variable
      !!focused?.id,
  )

  public saveClickHandler(): void {
    this._editingVariablesFeature.actions.saveFocused
      .from('Variable.SaveButton.Clicked')
      .dispatch()
  }

  public cancelClickHandler(): void {
    this._editingVariablesFeature.actions.discardFocused
      .from('Variable.CancelButton.Clicked')
      .dispatch()
  }
}
